// extracted by mini-css-extract-plugin
export default {"Container":"Taken_Container__NxSzO","table":"Taken_table__1FzoT","video-icon":"Taken_video-icon__2oyGG","link-upload":"Taken_link-upload__0aN3H","progress":"Taken_progress__sER29"};